'use strict';
var parent = require('../../stable/instance/sort');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/sort.js
// module id = 538
// module chunks = 13